module.exports = __webpack_public_path__ + "static/img/bg01.7efe53b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg01.png
// module id = jBbT
// module chunks = 2